import React, { Fragment, useMemo, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Badge } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { useGetStocktakesQuery } from '../../../../store/services/inventoryApi';
import { Eye, Plus, Play } from 'react-feather';

const Stocktake = () => {
    const navigate = useNavigate();
    const [statusFilter, setStatusFilter] = useState('');
    const { data: stocktakesData, isLoading } = useGetStocktakesQuery({ status: statusFilter || undefined });

    const stocktakes = useMemo(() => {
        if (!stocktakesData) return [];
        return Array.isArray(stocktakesData) ? stocktakesData : (stocktakesData.data || []);
    }, [stocktakesData]);

    const columns = [
        {
            name: 'ST ID',
            selector: row => row.stocktakeNumber || row._id.slice(-6).toUpperCase(),
            sortable: true,
            width: '180px'
        },
        {
            name: 'Store',
            selector: row => row.storeId?.storeName || 'N/A',
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            cell: row => <Badge color={row.type === 'Full' ? 'primary' : 'info'}>{row.type}</Badge>
        },
        {
            name: 'Date',
            selector: row => new Date(row.createdAt).toLocaleDateString(),
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            cell: row => {
                let color = 'secondary';
                if (row.status === 'InProgress') color = 'warning';
                if (row.status === 'Completed') color = 'success';
                return <Badge color={color}>{row.status}</Badge>;
            }
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="d-flex gap-2">
                    {row.status === 'InProgress' ? (
                        <Button color="warning" size="xs" onClick={() => navigate(`/inventory/stocktakes/session/${row._id}`)} title="Continue Counting">
                            <Play size={14} />
                        </Button>
                    ) : (
                        <Button color="info" size="xs" onClick={() => navigate(`/inventory/stocktakes/${row._id}`)} title="View Details">
                            <Eye size={14} />
                        </Button>
                    )}
                </div>
            )
        }
    ];

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Stocktake" parent="Inventory" title="Physical Counts" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h5>Inventory Stocktakes</h5>
                                <Button color="primary" onClick={() => navigate('/inventory/stocktakes/create')}>
                                    <Plus size={14} className="me-1" /> New Stocktake
                                </Button>
                            </CardHeader>
                            <CardBody>
                                <div className="mb-3 d-flex gap-2">
                                    <Button color={statusFilter === '' ? 'primary' : 'light'} size="sm" onClick={() => setStatusFilter('')}>All</Button>
                                    <Button color={statusFilter === 'InProgress' ? 'primary' : 'light'} size="sm" onClick={() => setStatusFilter('InProgress')}>In Progress</Button>
                                    <Button color={statusFilter === 'Completed' ? 'primary' : 'light'} size="sm" onClick={() => setStatusFilter('Completed')}>Completed</Button>
                                </div>
                                <DataTable
                                    columns={columns}
                                    data={stocktakes}
                                    pagination
                                    progressPending={isLoading}
                                    highlightOnHover
                                    striped
                                    responsive
                                    noDataComponent={<div className="p-4 text-center text-muted">No stocktake sessions found</div>}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default Stocktake;
